/* Sleepaxa PDP enhancements: clean H1 split + sticky add-to-cart bar.

   H1: The full GEO title stays in <title>, meta, og:title and JSON-LD (all untouched).
   On the page the H1 shows brand+model+category, and the keyword tail moves to a
   visible muted line directly under the H1 - so every keyword remains on-page.

   Sticky bar: appears when the main Add to cart button scrolls out of view (above).
   Clicking it triggers the real form button, so variant, prescription upload and
   cart drawer logic all behave exactly as normal.
   Hides itself whenever the cart drawer / any theme off-canvas is open. The theme
   (Quick Breeze / bls) adds class "hside_opened" to <html> for every off-canvas
   open (cart drawer, menu, search) - that is the primary signal, with a geometric
   on-screen check as fallback - so the bar never overlaps the drawer's Checkout.
   Mobile: title+price row, full-width Add to cart button BELOW it, raised above the
   WhatsApp widget so the button is never covered. Desktop: bottom-left panel. */
(function(){
  function go(){
    var h=document.querySelector('.sxp-title');
    if(!h || h._sxh) return;
    var full=(h.textContent||'').trim();
    if(!full){ return; }
    var seps=[' – ',' — ',' | ',' - '];
    var idx=-1;
    for(var i=0;i<seps.length;i++){
      var j=full.indexOf(seps[i]);
      if(j>0 && (idx<0 || j<idx)) idx=j;
    }
    if(idx<8){ h._sxh=1; return; }
    var shortT=full.slice(0,idx).trim();
    var rest=full.slice(idx).replace(/^[\s–—|-]+/,'').trim();
    if(!shortT || !rest){ h._sxh=1; return; }
    h.textContent=shortT;
    h._sxh=1;
    var kw=document.createElement('div');
    kw.className='sxh-kw';
    kw.textContent=rest.replace(/\s*\|\s*/g,'  ·  ');
    h.parentNode.insertBefore(kw, h.nextSibling);
  }
  go();
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',go); }
  setTimeout(go,300);
  setTimeout(go,900);
})();

/* Sticky add-to-cart */
(function(){
  var bar=null;

  function css(){
    if(document.getElementById('sxstk-css')) return;
    var s=document.createElement('style');
    s.id='sxstk-css';
    s.textContent='.sxstk{position:fixed;left:0;right:0;bottom:0;z-index:2147482000;background:rgba(255,255,255,.97);-webkit-backdrop-filter:blur(12px);backdrop-filter:blur(12px);border-top:1px solid #E7E1D6;padding:10px 14px calc(10px + env(safe-area-inset-bottom));display:none;box-shadow:0 -6px 24px rgba(20,18,15,.08);font-family:"Instrument Sans",-apple-system,BlinkMacSystemFont,sans-serif}'+
    '.sxstk.on{display:flex;animation:sxstkUp .25s ease}'+
    /* hard kill while any off-canvas is open, independent of the JS timer */
    'html.hside_opened .sxstk{display:none !important}'+
    '@keyframes sxstkUp{from{transform:translateY(100%)}to{transform:none}}'+
    /* Mobile: column - title+price row on top, full-width button below */
    '.sxstk{flex-direction:column;align-items:stretch;gap:9px}'+
    '.sxstk .sxstk-in{display:flex;align-items:baseline;gap:10px;min-width:0}'+
    '.sxstk .sxstk-t{flex:1;font-size:12.5px;font-weight:600;letter-spacing:-.01em;color:#14120F;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0}'+
    '.sxstk .sxstk-p{flex:none;font-size:13px;color:#7A7266;font-variant-numeric:tabular-nums}'+
    '.sxstk .sxstk-b{width:100%;background:#14120F;color:#fff;border:0;border-radius:10px;padding:15px;font-size:11.5px;letter-spacing:.14em;text-transform:uppercase;font-weight:600;cursor:pointer;font-family:inherit;transition:background .2s}'+
    '.sxstk .sxstk-b:hover{background:#000}'+
    '.sxstk .sxstk-b[disabled]{background:#C7BFB2;cursor:not-allowed}'+
    /* Desktop: bottom-left panel, row layout */
    '@media(min-width:901px){'+
    '.sxstk{right:auto;left:0;width:min(520px,44vw);border-right:1px solid #E7E1D6;border-top-right-radius:14px;padding:12px 22px;flex-direction:row;align-items:center;gap:14px}'+
    '.sxstk .sxstk-in{flex:1;display:block}'+
    '.sxstk .sxstk-b{width:auto;flex:none;padding:15px 24px}'+
    '}';
    document.head.appendChild(s);
  }

  function sync(){
    if(!bar) return;
    var t=document.querySelector('.sxp-title');
    var p=document.querySelector('[data-price]');
    var main=document.querySelector('.sxp-cta');
    bar.querySelector('.sxstk-t').textContent=t?t.textContent.trim():'';
    bar.querySelector('.sxstk-p').textContent=p?p.textContent.trim():'';
    var b=bar.querySelector('.sxstk-b');
    if(main){
      b.disabled=!!main.disabled;
      b.textContent=main.disabled?'Sold out':'Add to cart';
    }
  }

  /* Cart drawer / menu / search off-canvas open?
     Primary: theme adds hside_opened to <html> for every off-canvas.
     Also: bls__opend-popup / bls__opend-popup-header containers, [open] canvases,
     and a geometric on-screen fallback. */
  function overlayOpen(){
    var de=document.documentElement;
    if(de.classList.contains('hside_opened')) return true;
    if(document.querySelector('.bls__opend-popup, .bls__opend-popup-header, .bls__canvas[open]')) return true;
    var els=document.querySelectorAll('.bls__canvas, .bls__canvas-top, .bls-minicart-wrapper');
    var vw=window.innerWidth, vh=window.innerHeight;
    for(var i=0;i<els.length;i++){
      var s=getComputedStyle(els[i]);
      if(s.display==='none' || s.visibility==='hidden') continue;
      var r=els[i].getBoundingClientRect();
      if(r.width>40 && r.height>40 && r.left<vw-8 && r.right>8 && r.top<vh-8 && r.bottom>8) return true;
    }
    return false;
  }

  function tick(){
    if(!bar) return;
    if(overlayOpen()){ bar.classList.remove('on'); return; }
    var cta=document.querySelector('.sxp-cta');
    if(!cta){ bar.classList.remove('on'); return; }
    var r=cta.getBoundingClientRect();
    if(r.bottom<0){ if(!bar.classList.contains('on')){ sync(); bar.classList.add('on'); } }
    else { bar.classList.remove('on'); }
  }

  function build(){
    if(bar) return;
    var cta=document.querySelector('.sxp-cta');
    if(!cta) return;
    css();
    bar=document.createElement('div');
    bar.className='sxstk';
    bar.innerHTML='<div class="sxstk-in"><div class="sxstk-t"></div><div class="sxstk-p"></div></div><button type="button" class="sxstk-b">Add to cart</button>';
    document.body.appendChild(bar);

    bar.querySelector('.sxstk-b').addEventListener('click',function(){
      var main=document.querySelector('.sxp-cta');
      if(main && !main.disabled){ main.click(); }
      /* the click opens the cart drawer - hide immediately, don't wait for the timer */
      setTimeout(tick,250);
      setTimeout(tick,900);
    });

    /* clicks anywhere (cart icon, drawer close X, overlay) re-evaluate quickly */
    document.addEventListener('click',function(){ setTimeout(tick,200); }, true);

    /* react instantly when the theme toggles hside_opened on <html> */
    if(window.MutationObserver){
      new MutationObserver(tick).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
    }

    sync();
    document.querySelectorAll('.sxp-opt').forEach(function(b){
      b.addEventListener('click',function(){ setTimeout(sync,150); });
    });

    window.addEventListener('scroll',tick,{passive:true});
    window.addEventListener('resize',tick,{passive:true});
    setInterval(tick,400);
    tick();
  }

  function go(){ build(); sync(); tick(); }
  go();
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',go); }
  setTimeout(go,500);
  setTimeout(go,1400);
})();
